import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PLATFORM_URL } from '@core/config/config.service';
import { EMPTY_GUID } from '@core/constants/empty-guid.constant';
import { AccountNotesResponse } from '@core/model';

@Injectable({
  providedIn: 'root'
})
export class NotesService {
  constructor(
    private readonly http: HttpClient,
    @Inject(API_PLATFORM_URL) private readonly apiPlatformUrl: string
  ) {}

  public createNewNote(data: any): Observable<any> {
    return this.http.put<any>(
      `${this.apiPlatformUrl}${data.tenantId}/AccountNote/createNote`,
      data
    );
  }

  public updateNoteByNoteId(data: any): Observable<any> {
    return this.http.patch<boolean>(
      `${this.apiPlatformUrl}${data.tenantId}/AccountNote/UpdateNotebyNoteId/${data.noteId}`,
      data
    );
  }

  getAccountNotes(userId: string): Observable<AccountNotesResponse> {
    const tenantId = EMPTY_GUID;
    return this.http.get<any>(
      `${this.apiPlatformUrl}${tenantId}/AccountNote/getAccountNotesByUser/${userId}`
    );
  }

  public getAccountNoteByNoteId(noteId: string): Observable<any> {
    const tenantId = EMPTY_GUID;
    return this.http.get<any>(
      `${this.apiPlatformUrl}${tenantId}/AccountNote/getAccountNotesByNoteId/${noteId}`
    );
  }
}
